import React from 'react';
import FilterRange from '@/creditflowresearch/ui/common/components/organisms/Filters/components/FilterRange';
import FilterSection from '@/creditflowresearch/ui/common/components/organisms/Filters/components/FilterSection';

interface IProps {
  sectionId?: string,
  sectionTitle?: string,
  isVisible?: boolean,
  onSectionToggle?: () => void,
  filterName?: string,
  minValue?: number,
  maxValue?: number,
  step?: number,
  decimals?: number,
  selectedRangeValue?: {
    min: number,
    max: number,
  },
  handleFilterUpdate?: (value) => void,
  children?: React.ReactNode,
  disabled?: boolean,
  inputValueFormatter?: () => void,
}

const Range = ({
  sectionId,
  sectionTitle,
  isVisible,
  filterName,
  selectedRangeValue,
  minValue,
  maxValue,
  step,
  decimals,
  children,
  disabled,
  inputValueFormatter,
  onSectionToggle,
  handleFilterUpdate,
}: IProps) => {
  return (
    <FilterSection
      sectionId={ sectionId }
      headerComponent={ sectionTitle }
      isVisible={ isVisible }
      onSectionToggle={ onSectionToggle }
    >
      <FilterRange
        disabled={ disabled }
        minValue={ minValue }
        maxValue={ maxValue }
        value={ selectedRangeValue }
        step={ step }
        decimals={ decimals }
        inputValueFormatter={ inputValueFormatter }
        onChange={ (range) => handleFilterUpdate({
              [filterName]: {
                range,
                minValue,
                maxValue,
              },
            }) }
      />
      { children }
    </FilterSection>
  );
};

export default Range;
